/**
 * @todo Move this file as it's not limited to portals. --hrivera
 */

const formatDateForFotoscapeOptions = {
  weekday: 'short' as 'short' | 'long' | 'narrow', // For "ddd"
  month: 'long' as 'short' | 'long' | 'narrow' | 'numeric' | '2-digit', // For "MMM"
  day: 'numeric' as 'numeric' | '2-digit' // For "D"
}

export const formatDateForFotoscape = (language: string) => {
  const now = new Date()
  const locale = languageMap[language] || (isEnglish.includes(language) ? 'en-US' : language)
  const formatter = new Intl.DateTimeFormat(locale, formatDateForFotoscapeOptions) // Adjust locale if needed
  const formattedParts = formatter.formatToParts(now)

  const weekday = formattedParts.find(part => part.type === 'weekday')?.value || ''
  const month = formattedParts.find(part => part.type === 'month')?.value || ''
  const dayOfMonth = formattedParts.find(part => part.type === 'day')?.value || ''

  return `${weekday}, ${month} ${dayOfMonth}`
}

const formatDateOptions = {
  weekday: 'short' as 'short' | 'long' | 'narrow', // For "ddd"
  month: 'short' as 'short' | 'long' | 'narrow' | 'numeric' | '2-digit', // For "MMM"
  day: 'numeric' as 'numeric' | '2-digit' // For "D"
}

export const formatDate = language => {
  const now = new Date() // Get the current date

  // Map language to supported locales
  const locale = languageMap[language] || (isEnglish.includes(language) ? 'en-US' : language)
  const formatter = new Intl.DateTimeFormat(locale, formatDateOptions)
  const formattedParts = formatter.formatToParts(now)

  switch (language) {
    case 'es':
      return `${getFormattedPart(formattedParts, 'day')} de ${getFormattedPart(formattedParts, 'month')}`
    case 'de-at':
      return `${getFormattedPart(formattedParts, 'day')}. ${new Intl.DateTimeFormat(locale, { month: 'long' }).format(now)}`
    default:
      return `${getFormattedPart(formattedParts, 'weekday')}, ${getFormattedPart(formattedParts, 'month')} ${getFormattedPart(formattedParts, 'day')}`
  }
}

// Helper function to extract specific formatted parts
function getFormattedPart(parts, type) {
  return parts.find(part => part.type === type)?.value || ''
}

const isEnglish = ['en-us', 'en-in', 'en-at', 'en-it', 'en-tn', 'en-ph']
const languageMap = {
  'de-at': 'de-AT', // Adjusted to match Intl.DateTimeFormat locale format
  'fr-ca': 'fr-CA',
  'es-mx': 'es-MX'
}